import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { DatasetPage } from '@/components/DataVault/DatasetPage'
import { datasets } from '@/components/DataVault/datasets'
import {
  dataVaultSearchSchema,
  EMPTY_SEARCH,
  withoutDataVaultDefaults,
  type DataVaultSearch,
} from '@/components/DataVault/search'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/data-vault/ticket-exceptions')({
  validateSearch: dataVaultSearchSchema,
  // A link to this page carries no defaults: the clean URL is the default view.
  search: { middlewares: [stripSearchParams(EMPTY_SEARCH)] },
  component: TicketExceptionsRoute,
})

function TicketExceptionsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<DataVaultSearch>) =>
      void navigate({
        search: (current) => withoutDataVaultDefaults({ ...current, ...next }),
        replace: true,
      }),
    [navigate],
  )
  return (
    <DatasetPage
      config={datasets['ticket-exceptions']}
      search={search}
      onSearchChange={onSearchChange}
    />
  )
}
